import { useRef, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import api from '../../services/api';
import { IUseAxios, IParams } from './types';

export const useAxios = (): IUseAxios => {
    const [response, setResponse] = useState<AxiosResponse<any> | null>(null);
    const [error, setError] = useState<Error | null>(null);
    const [loading, setLoading] = useState(false);
    const requestIdRef = useRef(0);

    const fetch = async (params: IParams) => {
        requestIdRef.current += 1;
        const requestId = requestIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const result = await api.request(params);
            if (result.status === 499) {
                if (requestId === requestIdRef.current) {
                    setLoading(false);
                }
                return {
                    statusCode: 499,
                };
            }
            if (requestId === requestIdRef.current) {
                setResponse(result);
                setError(null);
                setLoading(false);
            }
            return result;
        } catch (errors: any) {
            const isCanceledRequest =
                axios.isCancel(errors) ||
                errors?.code === 'ERR_CANCELED' ||
                errors?.name === 'CanceledError' ||
                errors?.message === 'Request Cancelada';

            if (isCanceledRequest) {
                if (requestId === requestIdRef.current) {
                    setLoading(false);
                }
                return;
            }
            setError(errors);
            setLoading(false);
            if (requestId === requestIdRef.current) {
                setError(errors);
                setLoading(false);
            }
            return errors;
        }
    };

    return { error, loading, response, fetch };
};

export default useAxios;
